import React from 'react';

const ChatHeader = ({ chat, chatType, onShowGroupInfo, onToggleTheme, isDark }) => {
    return (
        <div className="chat-header">
            <div className="contact-info" onClick={chatType === 'group' ? onShowGroupInfo : undefined}>
                <div className={`chat-avatar ${chatType === 'group' ? 'group-avatar' : ''}`}>
                    {chat.avatar}
                </div>
                <div>
                    <h3 style={{ margin: 0 }}>{chat.name}</h3>
                    <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                        {chatType === 'private' ? (
                            <><i className="fas fa-circle" style={{ color: 'var(--primary)', fontSize: '0.7rem' }}></i> {chat.status || "онлайн"}</>
                        ) : (
                            <><i className="fas fa-users" style={{ color: 'var(--group-primary)' }}></i> {chat.members.length} участников</>
                        )}
                    </span>
                </div>
            </div>
            <div className="group-actions">
                {chatType === 'group' && (
                    <button className="btn-icon group-action-btn" onClick={onShowGroupInfo} title="Информация о группе">
                        <i className="fas fa-info-circle"></i>
                    </button>
                )}
                <button className="btn-outline btn-sm" onClick={onToggleTheme}>
                    <i className={`fas ${isDark ? 'fa-sun' : 'fa-moon'}`}></i> Тема
                </button>
            </div>
        </div>
    );
};

export default ChatHeader;
